<div class="sk-container" [ngClass]="{ 'sk-loading': state.loading }">
    <outlet-status [skeletonType]="'GENERIC_FULL'" [state]="state">
        <request-error (reloadFn)="reloadComponent()"></request-error>
    </outlet-status>
    @if (!state.loading && !state.error) {
        <div class="tab-content promotion-container" data-crlat="tabContent" [class.grouped]="groupedPromotions">
            <!-- Display as list -->
            @if (validPromotions) {
                <ng-container *ngTemplateOutlet="listTpl; context: { items: validPromotions }"></ng-container>
                @if (!validPromotions.length) {
                    <div class="item-inner text-center text-bold" [i18n]="'promotions.noPromotionsFound'" data-crlat="noPromotion"></div>
                }
            }

            <!-- Display as groups with lists -->
            @if (groupedPromotions) {
                @for (group of groupedPromotions.promotionsBySection; track trackGroupBy($index, group)) {
                    @if (group.availablePromotions?.length) {
                        <div class="promotion-group">
                            <div class="promotion-group-header">
                                @if (group.unassigned) {
                                    <span [i18n]="'promotions.unassignedGroup'"></span>
                                }
                                @if (!group.unassigned) {
                                    <span [textContent]="group.name"></span>
                                }
                            </div>
                            <ng-container *ngTemplateOutlet="listTpl; context: { items: group.availablePromotions }"></ng-container>
                            @if (!group.availablePromotions.length) {
                                <div class="item-inner text-center text-bold" [i18n]="'promotions.noPromotionsFound'" data-crlat="noPromotion"></div>
                            }
                        </div>
                    }
                }
                @if (!availableGroupedPromotions) {
                    <div class="item-inner text-center text-bold" [i18n]="'promotions.noPromotionsFound'" data-crlat="noPromotion"></div>
                }
            }
        </div>
    }

    <!-- List template -->
    <ng-template #listTpl let-items="items">
        <section class="promotion-item" *ngFor="let promotion of items; trackBy: trackPromotionBy" data-crlat="promotion">
            @if (promotion.uriMedium && !promotion.showsitecoreBanner) {
                <img [attr.src]="promotion.uriMedium" data-crlat="uriMedium" />
            }
            @if (promotion.showsitecoreBanner) {
                <div>
                    <a
                        class="lc-offer__link"
                        [href]="promotionsService.isEmptyPromotionValue(promotion.sitecoreBanner.bannerLink, '', 'href')"
                        [target]="promotionsService.isEmptyPromotionValue(promotion.sitecoreBanner.bannerLink, '', 'target')">
                        @if (promotion.sitecoreBanner.backgroundImage) {
                            <img
                                class="bg-image lc-offer__image"
                                [attr.src]="promotion.sitecoreBanner.backgroundImage.src"
                                [alt]="promotion.sitecoreBanner.backgroundImage.alt" />
                        }
                        <div class="offer-text">
                            @if (promotion.sitecoreBanner.foregroundImage) {
                                <img [attr.src]="promotion.sitecoreBanner.foregroundImage.src" [alt]="promotion.sitecoreBanner.foregroundImage.alt" />
                            }
                            @if (promotion.sitecoreBanner.introductoryText) {
                                <div class="offer-introductorytext" [textContent]="promotion.sitecoreBanner.introductoryText"></div>
                            }
                            @if (promotion.sitecoreBanner.title) {
                                <div class="offer-title" [textContent]="promotion.sitecoreBanner.title"></div>
                            }
                            @if (promotion.sitecoreBanner.subTitle) {
                                <div class="offer-subtitle" [textContent]="promotion.sitecoreBanner.subTitle"></div>
                            }
                        </div>
                        @if (promotion.sitecoreBanner.keyTermsAndConditions) {
                            <a
                                class="lc-offer__terms"
                                [href]="
                                    promotionsService.isEmptyPromotionValue(
                                        promotion.sitecoreBanner.bannerLink,
                                        promotion.sitecoreBanner.termsAndConditionsLink,
                                        'href'
                                    )
                                "
                                [target]="
                                    promotionsService.isEmptyPromotionValue(
                                        promotion.sitecoreBanner.bannerLink,
                                        promotion.sitecoreBanner.termsAndConditionsLink,
                                        'target'
                                    )
                                ">
                                <div class="lc-offer__text" [innerHTML]="promotion.sitecoreBanner.keyTermsAndConditions"></div>
                            </a>
                        }
                    </a>
                </div>
            }

            <span [innerHTML]="promotion.title" class="promotion-title" data-crlat="promotion.title"></span>
            <div class="promotion-content" data-crlat="promotion.content">
                <p class="clamp-lines" [innerHTML]="promotion.shortDescription" data-crlat="shortDescription"></p>
                <!-- RSS -->
                @if (!isPromoPage) {
                    <a
                        class="flat-btn btn-coral"
                        [routerLink]="setTargetUriforRss(promotion)"
                        [i18n]="'promotions.footerMore'"
                        (click)="sendGTM(promotion, $event)"
                        data-crlat="moreInfo"></a>
                } @else {
                    <a
                        class="flat-btn btn-coral"
                        href="javascript:void(0);"
                        [i18n]="'promotions.footerMore'"
                        (click)="sendGTM(promotion, $event); postPromoUrl(promotion)"
                        data-crlat="moreInfo"></a>
                }
            </div>
        </section>
    </ng-template>
</div>
